import axios from 'axios';

// Add a response interceptor to handle global errors like 429 (Too Many Requests)
export const setupAxiosInterceptors = () => {
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 429) {
                // Dispatch a global event to notify the App component
                const message = error.response.data && error.response.data.message 
                    ? error.response.data.message 
                    : "Action blocked due to too many requests. Please try again later.";
                
                window.dispatchEvent(new CustomEvent('api-rate-limit-exceeded', { detail: { message } }));
            }
            return Promise.reject(error);
        }
    );
};
